<template>
  <section class="main">
    <TheHeader />
    <div class="container pt-5">
      <div class="row">
        <div class="col">
          <h3>Minha Conta</h3>
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <nav aria-label="breadcrumb" id="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Meu Perfil
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-3">
          <div
            class="nav flex-column nav-pills nav-perfil"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <router-link class="nav-link" :to="{ name: 'meuperfil' }">
              <span class="d-md-flex">Dados Cadastrais</span>
              <i class="material-icons">person</i>
            </router-link>
            <router-link class="nav-link" :to="{ name: 'resetsenha' }">
              <span class="d-md-flex">Trocar Senha</span>
              <i class="material-icons">https</i>
            </router-link>
            <router-link class="nav-link" role="tab" :to="{ name: 'meuplano' }">
              <span class="d-md-flex">Meu Plano</span>
              <i class="material-icons">work</i>
            </router-link>
            <!-- <router-link
              class="nav-link"
              role="tab"
              :to="{ name: 'meuschamados' }"
            >
              <span class="d-md-flex">Meus chamados</span>
              <i class="material-icons">flag</i>
            </router-link> -->
            <router-link
              class="nav-link"
              role="tab"
              :to="{ name: 'meuscursos' }"
            >
              <span class="d-md-flex">Meus Cursos</span>
              <i class="material-icons">school</i>
            </router-link>
          </div>
        </div>
        <div class="col-md-9">
          <transition mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>

    <TheFooter />
  </section>
</template>
<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
export default {
  name: "MeuPerfil",
  components: {
    TheHeader,
    TheFooter,
  },
  mounted() {
    this.$store.dispatch("getUserData");
  },
};
</script>

<style lang="scss" scoped>
@media screen and(max-width: 900px) {
  #v-pills-tab {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    margin-bottom: 1rem;
    a {
      width: 22%;
      text-align: center;
      justify-content: center;
      align-items: center;
      span {
        display: none;
      }
    }
  }
}
</style>
